var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;stroke:currentColor;}.cls-1{stroke-linecap:round;stroke-width:6px;}.cls-1,.cls-2{stroke-linejoin:round;}.cls-2,.cls-3{stroke-width:5.63px;}.cls-3{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.5,51.14a16,16,0,0,1,12.29,8.93s16.8,46.82,17.37,49.51,1.54,13.94,1.44,22.68,2.64,23.58-14.11,23.67H53.71c-16.75-.09-14-14.93-14.12-23.67s.86-20,1.44-22.68S58.41,60.07,58.41,60.07a15.93,15.93,0,0,1,12.28-8.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.34,155.83l.07,11a5.38,5.38,0,0,1-5.28,5.48H56.66a5.38,5.38,0,0,1-5.28-5.48l-.06-11m114.59,0,.06,11a5.38,5.38,0,0,1-5.28,5.48H147.23a5.39,5.39,0,0,1-5.29-5.48l-.06-11M46.45,86.17H37.87c-4.27,0-7.14,3.19-7.72,8v2.54c0,4.43,5.2,8,9.46,8M167.28,86.17h8.58c4.27,0,7.14,3.19,7.73,8v2.54c0,4.43-5.21,8-9.47,8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.37,
    y1: 95.28,
    x2: 170.5,
    y2: 95.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.38,155.91s-8.85-6.79-13.91-7.61-27.14-1.08-27.14-1.08-23.78.24-28.85,1.08-13.91,7.61-13.91,7.61M71.46,118h74.32m16.29,0a8.15,8.15,0,1,1-8.14-8.49A8.32,8.32,0,0,1,162.07,118Zm-90.61,0a8.15,8.15,0,1,1-8.14-8.49A8.32,8.32,0,0,1,71.46,118Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/CAR.dce2a62e51972a1109cad635434f44ba.svg";
export { ForwardRef as ReactComponent };